import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { signIn } from "../../../../ApiLayer/auth";

// import styles
import styles from "./SignInPage.module.scss";

const SignInPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset states
    setMessage("");
    setIsSuccess(null);
    
    // Validate inputs
    if (!email.trim() || !password.trim()) {
      setMessage("Please enter both email and password");
      setIsSuccess(false);
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage("Please enter a valid email address");
      setIsSuccess(false);
      return;
    }

    setIsLoading(true);
    
    try {
      const response = await signIn({ email, password });
      setMessage(response.message);
      setIsSuccess(response.success);
      
      if (response.success) {
        // Get the redirect path from location state or default to dashboard
        const from = location.state?.from?.pathname || '/admin/dashboard';
        navigate(from, { replace: true });
      }
    } catch (error) {
      setMessage("An unexpected error occurred. Please try again.");
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const messageClass =
    isSuccess === true
      ? styles.success
      : isSuccess === false
      ? styles.error
      : "";

  return (
    <div className={styles.solutionsCardContainer}>
      <div className={styles.solutionsCard}>
        <div className={styles.cardContent}>
          <div className={styles.solutionsCardTopRow}>
            <div className={styles.solutionsCardTitle}>Sign In</div>
          </div>
          {message && (
            <p className={`${styles.message} ${messageClass}`}>{message}</p>
          )}
          <hr className={styles.hr} />
          <form onSubmit={handleSubmit}>
            <div className={styles.inputsContainer}>
              <div className={styles.input}>
                <label>Email</label>
                <input
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  disabled={isLoading}
                  placeholder="Enter your email"
                />
              </div>
              <div className={styles.input}>
                <label>Password</label>
                <input
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  disabled={isLoading}
                  placeholder="Enter your password"
                />
              </div>
            </div>
            <div className={styles.buttonContainer}>
              <button 
                type="submit" 
                className={styles.orderNow}
                disabled={isLoading}
              >
                {isLoading ? 'Logging in...' : 'Log in'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
